import { InMemoryCache, ApolloLink, CombinedGraphQLErrors, CombinedProtocolErrors } from '@apollo/client/core';
import { ErrorLink } from '@apollo/client/link/error';
import { HttpLink } from 'apollo-angular/http';
import { SetContextLink } from '@apollo/client/link/context';
import { RetryLink } from '@apollo/client/link/retry';
import { environment } from 'environments/environment';
import { inject } from '@angular/core';

export function apolloInitializerDatwind() {

  const httpLink = inject(HttpLink);
  const authLink = new SetContextLink((prevContext, operation) => ({credentials: "include"}));

  const retryLink = new RetryLink({
    attempts: {
      max: 10,
      retryIf: (error) => !!error,
    },
    delay: {
      initial: 30000,
      max: 30000,
      jitter: false,
    },
  });
  
  const httpDatwind = httpLink.create({ uri: environment.graphql_datwind });
  const errorLink = new ErrorLink(({ error, operation }) => {
    if (CombinedGraphQLErrors.is(error)) {
      error.errors.forEach(({ message, locations, path }) =>
        console.error(`[GraphQL error API Datwind]: Message: "${message}", Operation: ${operation}, Path: ${path}, Locations: ${locations}`),
      );
    } else if (CombinedProtocolErrors.is(error)) {
      error.errors.forEach(({ message, extensions }) =>
        console.error(`[GraphQL error API Datwind]: Message: "${message}", Extensions: ${JSON.stringify(extensions)}`),
      );
    } else {
      console.error(`[Network error API Datwind]: ${error.name}`);
    }
  });

  return {
    datwind: {
      link: ApolloLink.from([errorLink, retryLink, authLink.concat(httpDatwind)]),
      cache: new InMemoryCache(),
    },
  };
}
